// POST to convert an SVG file
export const isSvgConversion = (type, _ref) => {
  let {
    resource
  } = _ref;
  return type === 'create' && (resource === 'svg.png' || resource === 'svg.pdf');
};